/**
 * Given an array of research network posts and an array of active filters,
 * return a filtered list of research posts that satisfy the active filters.
 * @param {Array} research - An array of research posts to filter.
 * @param {Array} activeFilters - An array of active filter objects to apply.
 * @returns {Array} A filtered array of research posts.
 */
const filterResearchNetwork = (research, activeFilters) => research
  .filter(({
    meta: {
      knight_foundation_krn_description: description = '',
      knight_foundation_krn_member: {
        id: memberId = 0,
        name: memberName = '',
      } = {},
      knight_foundation_krn_research_publish_date: publishDate = '',
    } = {},
    title: {
      rendered: title = '',
    } = {},
  }) => activeFilters.reduce((acc, { type, value }) => {
    // If this post is already marked as not matching, don't check further.
    if (! acc) {
      return acc;
    }

    // Fork for type of filter.
    switch (type) {
      case 'keyword':
        return title.toLowerCase().includes(value.toLowerCase())
          || description.toLowerCase().includes(value.toLowerCase())
          || memberName.toLowerCase().includes(value.toLowerCase());
      case 'network-member':
        return String(memberId) === value;
      case 'year-granted':
        // Exclude bad data from reduced array
        if ('string' !== typeof publishDate) {
          return null;
        }
        return publishDate.substring(0, 4) === value;
      default:
        break;
    }

    return acc;
  }, true));

export default filterResearchNetwork;
